import enums from '@/utils/enums';
import { hasPermission, hasPermittedRole } from '@/utils';
import { EVENTS } from '@/utils/constants';

export default {
  methods: {
    async getEvent(types, { onlyCount = false } = {}) {
      let username = this.user.username;
      if (!hasPermission(enums.supportViewProfiles)) return;
      if (!hasPermittedRole(enums.clientViewRoles)) return;
      const params = {
        types,
        onlyCount: onlyCount ? 1 : 0,
        username,
        ...this.getByEnterpriseParams
      };
      const data = await this.$store.dispatch(EVENTS.FETCH_EVENTS, { params });
      return data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/modules/events.js